module.exports = __webpack_public_path__ + "assets/back-arrow-4ce0f7.svg";